export enum STATUS_VALUE {
  Open = 'open',
}
